/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineIdDto } from './machineIdDto';
import { ImplementDataDto } from './implementDataDto';
import { MachineDataDto } from './machineDataDto';

export interface MachineStatsV2Dto {
  implementData?: Array<ImplementDataDto>;
  implementDataField?: Array<ImplementDataDto>;
  implementDataLocation?: Array<ImplementDataDto>;
  implementDataRoad?: Array<ImplementDataDto>;
  machine?: MachineIdDto;
  machineData?: MachineDataDto;
  machineDataField?: MachineDataDto;
  machineDataLocation?: MachineDataDto;
  machineDataRoad?: MachineDataDto;
}
